module.exports = {
	"contractName": "PaperScissorsStone",
	"abi": [
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "rps",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "winTimes",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_guess",
					"type": "uint8"
				}
			],
			"name": "guess",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "win",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405234801561001057600080fd5b506000805460ff191681556001805461ffff19166101001762ff000019166202000017905561026790819061004590396000f3006080604052600436106100615763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166339bde5a38114610066578063473ca96c146100945780634ba4c16b146100bd578063a19f09a1146100da575b600080fd5b34801561007257600080fd5b5061007e6004356100ef565b6040805160ff9092168252519081900360200190f35b3480156100a057600080fd5b506100a9610116565b604080519115158252519081900360200190f35b3480156100c957600080fd5b506100d860ff60043516610133565b005b3480156100e657600080fd5b5061007e610232565b600181600381106100fc57fe5b60209182820401919006915054906101000a900460ff1681565b6000805460ff1660031461012b57600061012e565b60015b905090565b60008160ff161015801561014a575060038160ff16105b151561015557600080fd5b600360ff602919430140166002805460ff19169290910660ff908116929092179081905582821691600191166003811061018b57fe5b602091828204019190069054906101000a900460ff1660010160ff1614156101c8576000805460ff8082166001011660ff1990911617905561022f565b60025460019060ff16600381106101db57fe5b602091828204019190069054906101000a900460ff1660ff166002148015610204575060ff8116155b15610224576000805460ff8082166001011660ff1990911617905561022f565b6000805460ff191690555b50565b60005460ff16815600a165627a7a72305820cd8021552fd4c100c617204d10cf19bd5730b4ff8993e67346bd64bb028a8c9b0029",
	"deployedBytecode": "0x6080604052600436106100615763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166339bde5a38114610066578063473ca96c146100945780634ba4c16b146100bd578063a19f09a1146100da575b600080fd5b34801561007257600080fd5b5061007e6004356100ef565b6040805160ff9092168252519081900360200190f35b3480156100a057600080fd5b506100a9610116565b604080519115158252519081900360200190f35b3480156100c957600080fd5b506100d860ff60043516610133565b005b3480156100e657600080fd5b5061007e610232565b600181600381106100fc57fe5b60209182820401919006915054906101000a900460ff1681565b6000805460ff1660031461012b57600061012e565b60015b905090565b60008160ff161015801561014a575060038160ff16105b151561015557600080fd5b600360ff602919430140166002805460ff19169290910660ff908116929092179081905582821691600191166003811061018b57fe5b602091828204019190069054906101000a900460ff1660010160ff1614156101c8576000805460ff8082166001011660ff1990911617905561022f565b60025460019060ff16600381106101db57fe5b602091828204019190069054906101000a900460ff1660ff166002148015610204575060ff8116155b15610224576000805460ff8082166001011660ff1990911617905561022f565b6000805460ff191690555b50565b60005460ff16815600a165627a7a72305820cd8021552fd4c100c617204d10cf19bd5730b4ff8993e67346bd64bb028a8c9b0029",
	"sourceMap": "26:623:20:-;;;128:108;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;182:1:20;171:12;;-1:-1:-1;;171:12:20;;;-1:-1:-1;189:10:20;;-1:-1:-1;;205:10:20;;;-1:-1:-1;;221:10:20;;;;;26:623;;;;;;;;",
	"deployedSourceMap": "26:623:20:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;83:19;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;83:19:20;;;;;;;;;;;;;;;;;;;;;;;;564:83;;8:9:-1;5:2;;;30:1;27;20:12;5:2;564:83:20;;;;;;;;;;;;;;;;;;;;;;240:320;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;240:320:20;;;;;;;;;58:21;;8:9:-1;5:2;;;30:1;27;20:12;5:2;58:21:20;;;;83:19;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;564:83::-;595:4;614:8;;;;626:1;614:13;:28;;637:5;614:28;;;630:4;614:28;607:35;;564:83;:::o;240:320::-;300:1;290:6;:11;;;;:25;;;;;314:1;305:6;:10;;;290:25;282:34;;;;;;;;323:11;:59;;-1:-1:-1;;323:59:20;381:1;337:45;-1:-1:-1;;359:12:20;:17;343:34;337:45;;;;;323:59;;;;;;;;;;393:30;;;;-1:-1:-1;;397:11:20;;393:16;;;;;;;;;;;;;;;;;;;;;;;;412:1;393:20;:30;;;389:167;;;433:8;:10;;;;;;;;;-1:-1:-1;;433:10:20;;;;;;389:167;;;464:11;;460:3;;464:11;;460:16;;;;;;;;;;;;;;;;;;;;;;;;;:21;;480:1;460:21;:36;;;;-1:-1:-1;485:11:20;;;;460:36;456:100;;;506:8;:10;;;;;;;;;-1:-1:-1;;506:10:20;;;;;;456:100;;;548:1;537:12;;-1:-1:-1;;537:12:20;;;456:100;240:320;:::o;58:21::-;;;;;;:::o",
	"source": "pragma solidity ^0.4.18;\n\ncontract PaperScissorsStone {\n  uint8 public winTimes;\n  uint8[3] public rps;\n  uint8 randomIndex;\n\n  function PaperScissorsStone() public {\n    winTimes = 0;\n    rps[0] = 0;\n    rps[1] = 1;\n    rps[2] = 2;\n  }\n\n  function guess(uint8 _guess) public {\n    require(_guess >= 0 && _guess < 3);\n\n    randomIndex = uint8(block.blockhash(block.number - 42)) % 3;\n\n    if (rps[randomIndex] + 1 == _guess) {\n      winTimes++;\n    } else if (rps[randomIndex] == 2 && _guess == 0) {\n      winTimes++;\n    } else {\n      winTimes = 0;\n    }\n  }\n\n  function win() public returns (bool) {\n    return winTimes == 3 ? true : false;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStone.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStone.sol",
		"exportedSymbols": {
			"PaperScissorsStone": [
				2070
			]
		},
		"id": 2071,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1961,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:20"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2070,
				"linearizedBaseContracts": [
					2070
				],
				"name": "PaperScissorsStone",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1963,
						"name": "winTimes",
						"nodeType": "VariableDeclaration",
						"scope": 2070,
						"src": "58:21:20",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 1962,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "58:5:20",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1967,
						"name": "rps",
						"nodeType": "VariableDeclaration",
						"scope": 2070,
						"src": "83:19:20",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_uint8_$3_storage",
							"typeString": "uint8[3]"
						},
						"typeName": {
							"baseType": {
								"id": 1964,
								"name": "uint8",
								"nodeType": "ElementaryTypeName",
								"src": "83:5:20",
								"typeDescriptions": {
									"typeIdentifier": "t_uint8",
									"typeString": "uint8"
								}
							},
							"id": 1966,
							"length": {
								"argumentTypes": null,
								"hexValue": "33",
								"id": 1965,
								"isConstant": false,
								"isLValue": false,
								"isPure": false,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "89:1:20",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								},
								"value": "3"
							},
							"nodeType": "ArrayTypeName",
							"src": "83:8:20",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_uint8_$3_storage_ptr",
								"typeString": "uint8[3]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1969,
						"name": "randomIndex",
						"nodeType": "VariableDeclaration",
						"scope": 2070,
						"src": "106:17:20",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 1968,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "106:5:20",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 1994,
							"nodeType": "Block",
							"src": "165:71:20",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1974,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1972,
											"name": "winTimes",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1963,
											"src": "171:8:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1973,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "182:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "171:12:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1975,
									"nodeType": "ExpressionStatement",
									"src": "171:12:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1980,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1976,
												"name": "rps",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1967,
												"src": "189:3:20",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint8_$3_storage",
													"typeString": "uint8[3] storage ref"
												}
											},
											"id": 1978,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1977,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "193:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "189:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1979,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "198:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "189:10:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1981,
									"nodeType": "ExpressionStatement",
									"src": "189:10:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1986,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1982,
												"name": "rps",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1967,
												"src": "205:3:20",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint8_$3_storage",
													"typeString": "uint8[3] storage ref"
												}
											},
											"id": 1984,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1983,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "209:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "205:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 1985,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "214:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "205:10:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1987,
									"nodeType": "ExpressionStatement",
									"src": "205:10:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1992,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1988,
												"name": "rps",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1967,
												"src": "221:3:20",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint8_$3_storage",
													"typeString": "uint8[3] storage ref"
												}
											},
											"id": 1990,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 1989,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "225:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "221:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 1991,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "230:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "221:10:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1993,
									"nodeType": "ExpressionStatement",
									"src": "221:10:20"
								}
							]
						},
						"documentation": null,
						"id": 1995,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "PaperScissorsStone",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1970,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "155:2:20"
						},
						"payable": false,
						"returnParameters": {
							"id": 1971,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "165:0:20"
						},
						"scope": 2070,
						"src": "128:108:20",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2055,
							"nodeType": "Block",
							"src": "276:284:20",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2007,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													},
													"id": 2003,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 2001,
														"name": "_guess",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1997,
														"src": "290:6:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">=",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 2002,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "300:1:20",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "290:11:20",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													},
													"id": 2006,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 2004,
														"name": "_guess",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1997,
														"src": "305:6:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "33",
														"id": 2005,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "314:1:20",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_3_by_1",
															"typeString": "int_const 3"
														},
														"value": "3"
													},
													"src": "305:10:20",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "290:25:20",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2000,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "282:7:20",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2008,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "282:34:20",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2009,
									"nodeType": "ExpressionStatement",
									"src": "282:34:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2022,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2010,
											"name": "randomIndex",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1969,
											"src": "323:11:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"id": 2021,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 2017,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 2014,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2927,
																		"src": "359:5:20",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 2015,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "number",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "359:12:20",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "3432",
																	"id": 2016,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "374:2:20",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_42_by_1",
																		"typeString": "int_const 42"
																	},
																	"value": "42"
																},
																"src": "359:17:20",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"expression": {
																"argumentTypes": null,
																"id": 2012,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2927,
																"src": "343:5:20",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 2013,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "blockhash",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "343:15:20",
															"typeDescriptions": {
																"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
																"typeString": "function (uint256) view returns (bytes32)"
															}
														},
														"id": 2018,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "343:34:20",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													],
													"id": 2011,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "337:5:20",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint8_$",
														"typeString": "type(uint8)"
													},
													"typeName": "uint8"
												},
												"id": 2019,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "337:41:20",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "%",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2020,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "381:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "337:45:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"src": "323:59:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 2023,
									"nodeType": "ExpressionStatement",
									"src": "323:59:20"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										},
										"id": 2030,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"id": 2028,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2024,
													"name": "rps",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1967,
													"src": "393:3:20",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint8_$3_storage",
														"typeString": "uint8[3] storage ref"
													}
												},
												"id": 2026,
												"indexExpression": {
													"argumentTypes": null,
													"id": 2025,
													"name": "randomIndex",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1969,
													"src": "397:11:20",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "393:16:20",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "+",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2027,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "412:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "393:20:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"id": 2029,
											"name": "_guess",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1997,
											"src": "417:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"src": "393:30:20",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"id": 2043,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												},
												"id": 2039,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2035,
														"name": "rps",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1967,
														"src": "460:3:20",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_uint8_$3_storage",
															"typeString": "uint8[3] storage ref"
														}
													},
													"id": 2037,
													"indexExpression": {
														"argumentTypes": null,
														"id": 2036,
														"name": "randomIndex",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1969,
														"src": "464:11:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "460:16:20",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2038,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "480:1:20",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"src": "460:21:20",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "&&",
											"rightExpression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												},
												"id": 2042,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2040,
													"name": "_guess",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1997,
													"src": "485:6:20",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2041,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "495:1:20",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "485:11:20",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"src": "460:36:20",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"id": 2052,
											"nodeType": "Block",
											"src": "529:27:20",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 2050,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 2048,
															"name": "winTimes",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1963,
															"src": "537:8:20",
															"typeDescriptions": {
																"typeIdentifier": "t_uint8",
																"typeString": "uint8"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2049,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "548:1:20",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "537:12:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"id": 2051,
													"nodeType": "ExpressionStatement",
													"src": "537:12:20"
												}
											]
										},
										"id": 2053,
										"nodeType": "IfStatement",
										"src": "456:100:20",
										"trueBody": {
											"id": 2047,
											"nodeType": "Block",
											"src": "498:25:20",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 2045,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "UnaryOperation",
														"operator": "++",
														"prefix": false,
														"src": "506:10:20",
														"subExpression": {
															"argumentTypes": null,
															"id": 2044,
															"name": "winTimes",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1963,
															"src": "506:8:20",
															"typeDescriptions": {
																"typeIdentifier": "t_uint8",
																"typeString": "uint8"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"id": 2046,
													"nodeType": "ExpressionStatement",
													"src": "506:10:20"
												}
											]
										}
									},
									"id": 2054,
									"nodeType": "IfStatement",
									"src": "389:167:20",
									"trueBody": {
										"id": 2034,
										"nodeType": "Block",
										"src": "425:25:20",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2032,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "UnaryOperation",
													"operator": "++",
													"prefix": false,
													"src": "433:10:20",
													"subExpression": {
														"argumentTypes": null,
														"id": 2031,
														"name": "winTimes",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1963,
														"src": "433:8:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"id": 2033,
												"nodeType": "ExpressionStatement",
												"src": "433:10:20"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2056,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "guess",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1998,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1997,
									"name": "_guess",
									"nodeType": "VariableDeclaration",
									"scope": 2056,
									"src": "255:12:20",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint8",
										"typeString": "uint8"
									},
									"typeName": {
										"id": 1996,
										"name": "uint8",
										"nodeType": "ElementaryTypeName",
										"src": "255:5:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "254:14:20"
						},
						"payable": false,
						"returnParameters": {
							"id": 1999,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "276:0:20"
						},
						"scope": 2070,
						"src": "240:320:20",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2068,
							"nodeType": "Block",
							"src": "601:46:20",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"id": 2063,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2061,
												"name": "winTimes",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1963,
												"src": "614:8:20",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2062,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "626:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "614:13:20",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseExpression": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 2065,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "637:5:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"id": 2066,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "Conditional",
										"src": "614:28:20",
										"trueExpression": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 2064,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "630:4:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2060,
									"id": 2067,
									"nodeType": "Return",
									"src": "607:35:20"
								}
							]
						},
						"documentation": null,
						"id": 2069,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "win",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2057,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "576:2:20"
						},
						"payable": false,
						"returnParameters": {
							"id": 2060,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2059,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2069,
									"src": "595:4:20",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2058,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "595:4:20",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "594:6:20"
						},
						"scope": 2070,
						"src": "564:83:20",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2071,
				"src": "26:623:20"
			}
		],
		"src": "0:650:20"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStone.sol",
		"exportedSymbols": {
			"PaperScissorsStone": [
				2070
			]
		},
		"id": 2071,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1961,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:20"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2070,
				"linearizedBaseContracts": [
					2070
				],
				"name": "PaperScissorsStone",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1963,
						"name": "winTimes",
						"nodeType": "VariableDeclaration",
						"scope": 2070,
						"src": "58:21:20",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 1962,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "58:5:20",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1967,
						"name": "rps",
						"nodeType": "VariableDeclaration",
						"scope": 2070,
						"src": "83:19:20",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_uint8_$3_storage",
							"typeString": "uint8[3]"
						},
						"typeName": {
							"baseType": {
								"id": 1964,
								"name": "uint8",
								"nodeType": "ElementaryTypeName",
								"src": "83:5:20",
								"typeDescriptions": {
									"typeIdentifier": "t_uint8",
									"typeString": "uint8"
								}
							},
							"id": 1966,
							"length": {
								"argumentTypes": null,
								"hexValue": "33",
								"id": 1965,
								"isConstant": false,
								"isLValue": false,
								"isPure": false,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "89:1:20",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								},
								"value": "3"
							},
							"nodeType": "ArrayTypeName",
							"src": "83:8:20",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_uint8_$3_storage_ptr",
								"typeString": "uint8[3]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1969,
						"name": "randomIndex",
						"nodeType": "VariableDeclaration",
						"scope": 2070,
						"src": "106:17:20",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 1968,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "106:5:20",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 1994,
							"nodeType": "Block",
							"src": "165:71:20",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1974,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1972,
											"name": "winTimes",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1963,
											"src": "171:8:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1973,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "182:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "171:12:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1975,
									"nodeType": "ExpressionStatement",
									"src": "171:12:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1980,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1976,
												"name": "rps",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1967,
												"src": "189:3:20",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint8_$3_storage",
													"typeString": "uint8[3] storage ref"
												}
											},
											"id": 1978,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1977,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "193:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "189:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1979,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "198:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "189:10:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1981,
									"nodeType": "ExpressionStatement",
									"src": "189:10:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1986,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1982,
												"name": "rps",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1967,
												"src": "205:3:20",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint8_$3_storage",
													"typeString": "uint8[3] storage ref"
												}
											},
											"id": 1984,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1983,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "209:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "205:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 1985,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "214:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "205:10:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1987,
									"nodeType": "ExpressionStatement",
									"src": "205:10:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1992,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1988,
												"name": "rps",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1967,
												"src": "221:3:20",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint8_$3_storage",
													"typeString": "uint8[3] storage ref"
												}
											},
											"id": 1990,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 1989,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "225:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "221:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 1991,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "230:1:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "221:10:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 1993,
									"nodeType": "ExpressionStatement",
									"src": "221:10:20"
								}
							]
						},
						"documentation": null,
						"id": 1995,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "PaperScissorsStone",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1970,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "155:2:20"
						},
						"payable": false,
						"returnParameters": {
							"id": 1971,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "165:0:20"
						},
						"scope": 2070,
						"src": "128:108:20",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2055,
							"nodeType": "Block",
							"src": "276:284:20",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2007,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													},
													"id": 2003,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 2001,
														"name": "_guess",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1997,
														"src": "290:6:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">=",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 2002,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "300:1:20",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "290:11:20",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													},
													"id": 2006,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 2004,
														"name": "_guess",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1997,
														"src": "305:6:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "33",
														"id": 2005,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "314:1:20",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_3_by_1",
															"typeString": "int_const 3"
														},
														"value": "3"
													},
													"src": "305:10:20",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "290:25:20",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2000,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "282:7:20",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2008,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "282:34:20",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2009,
									"nodeType": "ExpressionStatement",
									"src": "282:34:20"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2022,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2010,
											"name": "randomIndex",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1969,
											"src": "323:11:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"id": 2021,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 2017,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 2014,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2927,
																		"src": "359:5:20",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 2015,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "number",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "359:12:20",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "3432",
																	"id": 2016,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "374:2:20",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_42_by_1",
																		"typeString": "int_const 42"
																	},
																	"value": "42"
																},
																"src": "359:17:20",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"expression": {
																"argumentTypes": null,
																"id": 2012,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2927,
																"src": "343:5:20",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 2013,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "blockhash",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "343:15:20",
															"typeDescriptions": {
																"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
																"typeString": "function (uint256) view returns (bytes32)"
															}
														},
														"id": 2018,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "343:34:20",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													],
													"id": 2011,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "337:5:20",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint8_$",
														"typeString": "type(uint8)"
													},
													"typeName": "uint8"
												},
												"id": 2019,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "337:41:20",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "%",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2020,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "381:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "337:45:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"src": "323:59:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"id": 2023,
									"nodeType": "ExpressionStatement",
									"src": "323:59:20"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										},
										"id": 2030,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"id": 2028,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2024,
													"name": "rps",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1967,
													"src": "393:3:20",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint8_$3_storage",
														"typeString": "uint8[3] storage ref"
													}
												},
												"id": 2026,
												"indexExpression": {
													"argumentTypes": null,
													"id": 2025,
													"name": "randomIndex",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1969,
													"src": "397:11:20",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "393:16:20",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "+",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2027,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "412:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "393:20:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"id": 2029,
											"name": "_guess",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1997,
											"src": "417:6:20",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"src": "393:30:20",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"id": 2043,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												},
												"id": 2039,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2035,
														"name": "rps",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1967,
														"src": "460:3:20",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_uint8_$3_storage",
															"typeString": "uint8[3] storage ref"
														}
													},
													"id": 2037,
													"indexExpression": {
														"argumentTypes": null,
														"id": 2036,
														"name": "randomIndex",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1969,
														"src": "464:11:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "460:16:20",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2038,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "480:1:20",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"src": "460:21:20",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "&&",
											"rightExpression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												},
												"id": 2042,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2040,
													"name": "_guess",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1997,
													"src": "485:6:20",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2041,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "495:1:20",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "485:11:20",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"src": "460:36:20",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"id": 2052,
											"nodeType": "Block",
											"src": "529:27:20",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 2050,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 2048,
															"name": "winTimes",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1963,
															"src": "537:8:20",
															"typeDescriptions": {
																"typeIdentifier": "t_uint8",
																"typeString": "uint8"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2049,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "548:1:20",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "537:12:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"id": 2051,
													"nodeType": "ExpressionStatement",
													"src": "537:12:20"
												}
											]
										},
										"id": 2053,
										"nodeType": "IfStatement",
										"src": "456:100:20",
										"trueBody": {
											"id": 2047,
											"nodeType": "Block",
											"src": "498:25:20",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 2045,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "UnaryOperation",
														"operator": "++",
														"prefix": false,
														"src": "506:10:20",
														"subExpression": {
															"argumentTypes": null,
															"id": 2044,
															"name": "winTimes",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1963,
															"src": "506:8:20",
															"typeDescriptions": {
																"typeIdentifier": "t_uint8",
																"typeString": "uint8"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"id": 2046,
													"nodeType": "ExpressionStatement",
													"src": "506:10:20"
												}
											]
										}
									},
									"id": 2054,
									"nodeType": "IfStatement",
									"src": "389:167:20",
									"trueBody": {
										"id": 2034,
										"nodeType": "Block",
										"src": "425:25:20",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2032,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "UnaryOperation",
													"operator": "++",
													"prefix": false,
													"src": "433:10:20",
													"subExpression": {
														"argumentTypes": null,
														"id": 2031,
														"name": "winTimes",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1963,
														"src": "433:8:20",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"id": 2033,
												"nodeType": "ExpressionStatement",
												"src": "433:10:20"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2056,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "guess",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1998,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1997,
									"name": "_guess",
									"nodeType": "VariableDeclaration",
									"scope": 2056,
									"src": "255:12:20",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint8",
										"typeString": "uint8"
									},
									"typeName": {
										"id": 1996,
										"name": "uint8",
										"nodeType": "ElementaryTypeName",
										"src": "255:5:20",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "254:14:20"
						},
						"payable": false,
						"returnParameters": {
							"id": 1999,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "276:0:20"
						},
						"scope": 2070,
						"src": "240:320:20",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2068,
							"nodeType": "Block",
							"src": "601:46:20",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"id": 2063,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2061,
												"name": "winTimes",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1963,
												"src": "614:8:20",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2062,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "626:1:20",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "614:13:20",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseExpression": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 2065,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "637:5:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"id": 2066,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "Conditional",
										"src": "614:28:20",
										"trueExpression": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 2064,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "630:4:20",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2060,
									"id": 2067,
									"nodeType": "Return",
									"src": "607:35:20"
								}
							]
						},
						"documentation": null,
						"id": 2069,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "win",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2057,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "576:2:20"
						},
						"payable": false,
						"returnParameters": {
							"id": 2060,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2059,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2069,
									"src": "595:4:20",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2058,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "595:4:20",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "594:6:20"
						},
						"scope": 2070,
						"src": "564:83:20",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2071,
				"src": "26:623:20"
			}
		],
		"src": "0:650:20"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.807Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/PaperScissorsStone.json
// module id = 1049
// module chunks = 0